import React, { Component } from 'react'
import Styles from '../sass/layout/Skill.module.sass'

class Skill extends Component {
  render (){
    var SkillData = this.props.SkillData;
    return (
      <section className={Styles.skill}>
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-12 text-center">
              <h2>My tech Skills</h2>
            </div>
          </div>
          <div className="row mb-none-30">
            {
              SkillData.SkillItems.map(items=> {
                return(
                  <div className="col-lg-3 mb-30" key={items.id}>
                    <div className={Styles.skill__item}>
                      <div className={Styles.skill__item__icon}>
                        <i className={items.iconName}></i>
                      </div>
                      <h4 className={Styles.skill__item__title}>{items.title}</h4>
                    </div>
                  </div>
                )
              }) 
            }
          </div>
        </div>
      </section>
    )
  }
}

export default Skill